import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getInviteListFilter } from "./Services";

export const useGetInvites = (filter:any) => {
  const query = useQuery(
    [endpoints.getInviteListFilter,filter],
    () => {
      return getInviteListFilter(filter);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};
